module.exports = __webpack_public_path__ + "media/images/icon/icons8-User Manual-f08e529e04f6752de67124a7103032a1.png";